import { categoryOptions } from "./data";

export const productMainCategories = categoryOptions;

const subcategoriesByCategory = {
  "Electronics & Gadgets": [
    "Mobile Phones",
    "Laptops & Computers",
    "TVs & Audio",
    "Cameras",
    "Wearables",
    "Accessories",
    "Other",
  ],
  Groceries: [
    "Fresh Produce",
    "Dairy & Eggs",
    "Pantry Staples",
    "Frozen Foods",
    "Beverages",
    "Snacks",
    "Other",
  ],
  "Fashion & Accessories": [
    "Men's Clothing",
    "Women's Clothing",
    "Kids' Clothing",
    "Shoes",
    "Bags & Accessories",
    "Jewelry",
    "Other",
  ],
  "Home Appliances": [
    "Kitchen Appliances",
    "Laundry",
    "Cooling & Heating",
    "Small Appliances",
    "Other",
  ],
  "Real Estate & Housing": [
    "Rentals",
    "Sales",
    "Commercial",
    "Land",
    "Other",
  ],
  Furniture: [
    "Living Room",
    "Bedroom",
    "Office",
    "Outdoor",
    "Other",
  ],
  "Beauty, Spas & Wellness": [
    "Skincare",
    "Haircare",
    "Makeup",
    "Spa Services",
    "Wellness",
    "Other",
  ],
  "Baby & Mother Care": [
    "Baby Food",
    "Diapers & Wipes",
    "Baby Gear",
    "Maternity",
    "Toys",
    "Other",
  ],
  Electricals: [
    "Lighting",
    "Wiring & Cables",
    "Power Tools",
    "Electrical Accessories",
    "Other",
  ],
  Sports: [
    "Fitness",
    "Outdoor Sports",
    "Team Sports",
    "Sportswear",
    "Equipment",
    "Other",
  ],
  Automotive: [
    "Parts & Accessories",
    "Car Care",
    "Tyres",
    "Services",
    "Other",
  ],
  "Events and Entertainment": [
    "Concerts",
    "Festivals",
    "Theatre",
    "Sports Events",
    "Other",
  ],
  "Restaurants & Eateries": [
    "Fast Food",
    "Fine Dining",
    "Cafes",
    "Takeaway",
    "Other",
  ],
  "Pubs, Nightclubs & Lounges": [
    "Pubs",
    "Nightclubs",
    "Lounges",
    "Other",
  ],
  "Construction & Building Materials": [
    "Cement & Blocks",
    "Steel & Iron",
    "Plumbing",
    "Paint & Finishes",
    "Other",
  ],
  "Pet Care": [
    "Pet Food",
    "Pet Accessories",
    "Grooming",
    "Other",
  ],
  "Computing & IT": [
    "Software",
    "Hardware",
    "Networking",
    "IT Services",
    "Other",
  ],
  "Agriculture & Agribusiness": [
    "Seeds & Fertilizers",
    "Farm Equipment",
    "Livestock",
    "Produce",
    "Other",
  ],
  Education: [
    "Courses",
    "Books & Materials",
    "Tutoring",
    "Other",
  ],
  Hospitality: [
    "Hotels",
    "Resorts",
    "Guest Houses",
    "Other",
  ],
  "Tourism & Travel": [
    "Flights",
    "Hotels",
    "Tours",
    "Packages",
    "Other",
  ],
  Stationery: [
    "Office Supplies",
    "School Supplies",
    "Art Supplies",
    "Other",
  ],
};

export const getSubcategoriesFor = (category) =>
  subcategoriesByCategory[category] || ["General", "Other"];
